var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',[_c('ContactTemplate',{attrs:{"Contact":_vm.CustomerContact,"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }